export default __webpack_public_path__ + "static/media/tab-opened-blue.d21becbf.svg";